export enum DpkParam {

    SymbolId = "SymbolId",
    Direction = "Direction",
    StopLoss = "sl",
    TakeProfit = "tp",
    Method = "method",
    Currency = "currency",
    Amount = "amount",
    Ric = "ric",
    direction = "direction",
    Activity = "activity"
}
